import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface FilterAndVisualizationFilters {
  interventionType?: string
  currency?: string
  date?: string | null
}

const initialState: FilterAndVisualizationFilters = {
  interventionType: 'ACCOUNT_HOLDER',
  currency: undefined,
  date: undefined,
}

export const { actions: filterAndVisualizationActions, reducer: filterAndVisualizationReducer } =
  createSlice({
    name: '@app/filterAndVisualization',
    initialState,
    reducers: {
      setFilters: (state, { payload }: PayloadAction<FilterAndVisualizationFilters>) => {
        state.interventionType = payload.interventionType
        state.currency = payload.currency
        state.date = payload.date
      },
      clearFilters: (state) => {
        state.interventionType = undefined
        state.currency = undefined
        state.date = undefined
      },
    },
  })
